import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // paymentRunning: null,
    initialized: 0,
    cart: {
      OrderItemWebApi: []
    }
  },
  mutations: {
    updateCart (state, cart) {
      state.cart = cart
    },
    setInitialization(state, initialized) {
      state.initialized = initialized
    }
  }
})
